import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createPostageAccount, checkWorktagString, addAuthorizedUserToPostageAccount } from '../services/api';
import { useUser } from '../context/UserContext';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function PostageAccountCreate() {
    const [department, setDepartment] = useState('');
    const [worktagString, setWorktagString] = useState('');
    const [comments, setComments] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [existingAccount, setExistingAccount] = useState(null);
    const navigate = useNavigate();
    const { user } = useUser();

    const handleSubmit = async (event) => {
        event.preventDefault();
        const existing = await checkWorktagString(worktagString);
        if (existing) {
            setExistingAccount(existing);
            setShowModal(true);
        } else {
            try {
                const newAccount = {
                    department,
                    worktagString,
                    comments,
                    ownerNetId: user.netId,
                };
                const created = await createPostageAccount(newAccount);
                navigate(`/postage-account/${created.postageAccountNumber}`);
            } catch (error) {
                console.error('Failed to create postage account:', error);
            }
        }
    };

    const handleJoinExistingAccount = async () => {
        await addAuthorizedUserToPostageAccount(existingAccount.postageAccountNumber, user.netId);
        navigate(`/postage-account/${existingAccount.postageAccountNumber}`);
    };

    const handleClose = () => setShowModal(false);

    const handleViewAccount = () => navigate(`/postage-account/${existingAccount.postageAccountNumber}`);
    
    return (
        <div className="container">
            <div className="page-header"><h1 className="gradient-under">Create Postage Account</h1></div>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="department" className="form-label">Department</label>
                    <input type="text" className="form-control" id="department" value={department} onChange={(e) => setDepartment(e.target.value)} />
                </div>
                <div className="mb-3">
                    <label htmlFor="worktagString" className="form-label">Worktag String</label>
                    <input type="text" className="form-control" id="worktagString" value={worktagString} onChange={(e) => setWorktagString(e.target.value)} placeholder="Enter worktags separated by semicolons" />
                </div>
                <div className="mb-3">
                    <label htmlFor="comments" className="form-label">Comments</label>
                    <textarea className="form-control" id="comments" value={comments} onChange={(e) => setComments(e.target.value)}></textarea>
                </div>
                <button type="submit" className="btn btn-success">Create Account</button>
            </form>
            {showModal && existingAccount && (
                <Modal show={showModal} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Postage Account Already Exists</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {user.netId === existingAccount.owner.netId ?
                            <p>You already own postage account {existingAccount.postageAccountNumber}.</p> :
                            <p>Add yourself to postage account {existingAccount.postageAccountNumber}?</p>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {user.netId === existingAccount.owner.netId ? (
                            <>
                                <Button variant="secondary" onClick={handleClose}>
                                    Close
                                </Button>
                                <Button variant="primary" onClick={handleViewAccount}>
                                    View Account
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button variant="secondary" onClick={handleClose}>
                                    No
                                </Button>
                                <Button variant="primary" onClick={handleJoinExistingAccount}>
                                    Yes
                                </Button>
                            </>
                        )}
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    );
}

export default PostageAccountCreate;
